document.querySelectorAll('.product-carousel').forEach(carousel => {
  const track = carousel.querySelector('.product-carousel__track');
  const items = Array.from(track.children);
  const leftArrow = carousel.querySelector('.carousel-arrow--left');
  const rightArrow = carousel.querySelector('.carousel-arrow--right');
  const dotsContainer = carousel.querySelector('.carousel-dots');

  let index = 0;
  let visibleCount = 1;
  let isDragging = false;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = 0;

  function createDots() {
    dotsContainer.innerHTML = '';
    const dotCount = Math.ceil(items.length / visibleCount);
    for (let i = 0; i < dotCount; i++) {
      const dot = document.createElement('span');
      dot.classList.add('carousel-dot');
      if (i === 0) dot.classList.add('active');
      dot.dataset.index = i;
      dot.addEventListener('click', () => {
        index = i;
        updateCarousel();
        pauseAutoplay();
        setTimeout(resumeAutoplay, autoplayInterval);
      });
      dotsContainer.appendChild(dot);
    }
  }

  function getVisibleCount() {
    const w = window.innerWidth;
    if (w >= 900) return 3;
    if (w >= 600) return 2;
    return 1;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function updateCarousel() {
    visibleCount = getVisibleCount();
    createDots();

    const maxIndex = Math.ceil(items.length / visibleCount) - 1;
    index = clamp(index, 0, maxIndex);

    const slidePercent = 100 / visibleCount;
    const translateX = index * slidePercent;

    track.style.transition = 'transform 0.4s ease';
    track.style.transform = `translateX(-${translateX}%)`;

    // Update dots active state
    dotsContainer.querySelectorAll('.carousel-dot').forEach(dot => {
      dot.classList.remove('active');
    });
    if (dotsContainer.children[index]) {
      dotsContainer.children[index].classList.add('active');
    }
  }

  // Arrow buttons
  leftArrow.addEventListener('click', () => {
    index = Math.max(index - 1, 0);
    updateCarousel();
    pauseAutoplay();
    setTimeout(resumeAutoplay, autoplayInterval);
  });
  rightArrow.addEventListener('click', () => {
    const maxIndex = Math.ceil(items.length / visibleCount) - 1;
    index = Math.min(index + 1, maxIndex);
    updateCarousel();
    pauseAutoplay();
    setTimeout(resumeAutoplay, autoplayInterval);
  });

  // Touch / drag support for momentum swipe
  track.addEventListener('touchstart', touchStart);
  track.addEventListener('touchmove', touchMove);
  track.addEventListener('touchend', touchEnd);
  track.addEventListener('mousedown', touchStart);
  track.addEventListener('mousemove', touchMove);
  track.addEventListener('mouseup', touchEnd);
  track.addEventListener('mouseleave', touchEnd);

  function touchStart(event) {
    isDragging = true;
    startX = getPositionX(event);
    prevTranslate = currentTranslate;
    track.style.transition = 'none';
    cancelAnimationFrame(animationID);
    pauseAutoplay();
  }

  function touchMove(event) {
    if (!isDragging) return;
    const currentPosition = getPositionX(event);
    const deltaX = currentPosition - startX;
    const containerWidth = carousel.offsetWidth;
    const slideWidth = containerWidth / visibleCount;
    currentTranslate = prevTranslate + (deltaX / slideWidth) * 100;
    const maxTranslate = (items.length - visibleCount) * (100 / visibleCount);
    currentTranslate = clamp(currentTranslate, -maxTranslate, 0);
    track.style.transform = `translateX(${currentTranslate}%)`;
  }

  function touchEnd() {
    if (!isDragging) return;
    isDragging = false;
    const slidePercent = 100 / visibleCount;
    index = Math.round(-currentTranslate / slidePercent);
    updateCarousel();
    resumeAutoplay();
  }

  function getPositionX(event) {
    return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
  }

  // Autoplay settings
  const autoplayInterval = 4000; // 4 seconds
  let autoplayTimer = setInterval(() => {
    const maxIndex = Math.ceil(items.length / visibleCount) - 1;
    index = (index >= maxIndex) ? 0 : index + 1;
    updateCarousel();
  }, autoplayInterval);

  function pauseAutoplay() {
    clearInterval(autoplayTimer);
    autoplayTimer = null;
  }

  function resumeAutoplay() {
    if (!autoplayTimer) {
      autoplayTimer = setInterval(() => {
        const maxIndex = Math.ceil(items.length / visibleCount) - 1;
        index = (index >= maxIndex) ? 0 : index + 1;
        updateCarousel();
      }, autoplayInterval);
    }
  }

  // Handle window resize
  window.addEventListener('resize', () => {
    updateCarousel();
  });

  // Initialize carousel
  updateCarousel();
});
